import { IconCrownFilled } from '../../../../foundation/icons/IconCrownFilled/index.js';
import { IconTick } from '../../../../foundation/icons/IconTick/index.js';
import { IconStarFilled } from '../../../../foundation/icons/IconStarFilled/index.js';
import { IconTextNew } from '../../../../foundation/icons/IconTextNew/index.js';
import { IconTextTry } from '../../../../foundation/icons/IconTextTry/index.js';
import { IconTextBeta } from '../../../../foundation/icons/IconTextBeta/index.js';
import { IconAI } from '../../../../foundation/icons/IconAI/index.js';
import { IconTextPlus } from '../../../../foundation/icons/IconTextPlus/index.js';
import { IconTextPro } from '../../../../foundation/icons/IconTextPro/index.js';
import { IconHeartFilled } from '../../../../foundation/icons/IconHeartFilled/index.js';
import { IconProfileAddFilled } from '../../../../foundation/icons/IconProfileAddFilled/index.js';
import { IconCommentFilled } from '../../../../foundation/icons/IconCommentFilled/index.js';
import { IconReplay } from '../../../../foundation/icons/IconReplay/index.js';
import { IconImageFilled } from '../../../../foundation/icons/IconImageFilled/index.js';
import { IconBookmarkFilled } from '../../../../foundation/icons/IconBookmarkFilled/index.js';
import { IconTagFilled } from '../../../../foundation/icons/IconTagFilled/index.js';
import { IconEditFilled } from '../../../../foundation/icons/IconEditFilled/index.js';
import { IconStickerFilled } from '../../../../foundation/icons/IconStickerFilled/index.js';
import { IconChallengesFilled } from '../../../../foundation/icons/IconChallengesFilled/index.js';
import { IconAdminOutline } from '../../../../foundation/icons/IconAdminOutline/index.js';
import { IconShareFilled } from '../../../../foundation/icons/IconShareFilled/index.js';
import { IconPlus } from '../../../../foundation/icons/IconPlus/index.js';
import { IconFireFilled } from '../../../../foundation/icons/IconFireFilled/index.js';
import { IconTextGold } from '../../../../foundation/icons/IconTextGold/index.js';
import { IconTextPlusColored } from '../../../../foundation/icons/IconTextPlusColored/index.js';
import { IconTextProColored } from '../../../../foundation/icons/IconTextProColored/index.js';
import { IconTextGoldColored } from '../../../../foundation/icons/IconTextGoldColored/index.js';
import { IconTextFree } from '../../../../foundation/icons/IconTextFree/index.js';
import { IconTextAIAvatar } from '../../../../foundation/icons/IconTextAIAvatar/index.js';
import { IconTextPerformance } from '../../../../foundation/icons/IconTextPerformance/index.js';
import { IconTextEssentials } from '../../../../foundation/icons/IconTextEssentials/index.js';
import { IconTextLite } from '../../../../foundation/icons/IconTextLite/index.js';
import { IconTextMax } from '../../../../foundation/icons/IconTextMax/index.js';
import { IconTextLive } from '../../../../foundation/icons/IconTextLive/index.js';

var BadgeTypes;
(function (BadgeTypes) {
    BadgeTypes["Premium"] = "premium";
    BadgeTypes["Verified"] = "verified";
    BadgeTypes["Star"] = "star";
    BadgeTypes["Ambassador"] = "ambassador";
    BadgeTypes["MasterContributor"] = "masterContributor";
    BadgeTypes["MasterStoryteller"] = "masterStoryteller";
    BadgeTypes["Dot"] = "dot";
    BadgeTypes["DotPremium"] = "dotPremium";
    BadgeTypes["New"] = "new";
    BadgeTypes["NewPremium"] = "newPremium";
    BadgeTypes["Try"] = "try";
    BadgeTypes["TryPremium"] = "tryPremium";
    BadgeTypes["Beta"] = "beta";
    BadgeTypes["AiRectangle"] = "aiRectangle";
    BadgeTypes["AiCircle"] = "aiCircle";
    BadgeTypes["Plus"] = "plus";
    BadgeTypes["Pro"] = "pro";
    BadgeTypes["Like"] = "like";
    BadgeTypes["Follow"] = "follow";
    BadgeTypes["Comment"] = "comment";
    BadgeTypes["Replay"] = "replay";
    BadgeTypes["NewPost"] = "newPost";
    BadgeTypes["Save"] = "save";
    BadgeTypes["Tag"] = "tag";
    BadgeTypes["Mention"] = "mention";
    BadgeTypes["Remix"] = "remix";
    BadgeTypes["Sticker"] = "sticker";
    BadgeTypes["Challenges"] = "challenges";
    BadgeTypes["Admin"] = "admin";
    BadgeTypes["FileShare"] = "fileShare";
    BadgeTypes["FileJoined"] = "fileJoined";
    BadgeTypes["PlusCrown"] = "plusCrown";
    BadgeTypes["ProCrown"] = "proCrown";
    BadgeTypes["Gold"] = "gold";
    BadgeTypes["PlusReverse"] = "plusReverse";
    BadgeTypes["ProReverse"] = "proReverse";
    BadgeTypes["GoldReverse"] = "goldReverse";
    BadgeTypes["Free"] = "free";
    BadgeTypes["AiAvatar"] = "aiAvatar";
    BadgeTypes["ProTrial"] = "proTrial";
    BadgeTypes["PlusTrial"] = "plusTrial";
    BadgeTypes["CrownTrial"] = "crownTrial";
    BadgeTypes["Essentials"] = "essentials";
    BadgeTypes["Performance"] = "performance";
    BadgeTypes["Lite"] = "lite";
    BadgeTypes["Max"] = "max";
    BadgeTypes["Live"] = "live";
})(BadgeTypes || (BadgeTypes = {}));
const BadgeIcons = {
    premium: IconCrownFilled,
    verified: IconTick,
    star: IconStarFilled,
    ambassador: IconTick,
    masterContributor: IconStarFilled,
    masterStoryteller: IconStarFilled,
    dot: () => null,
    dotPremium: () => null,
    new: IconTextNew,
    newPremium: IconTextNew,
    try: IconTextTry,
    tryPremium: IconTextTry,
    beta: IconTextBeta,
    aiRectangle: IconAI,
    aiCircle: IconAI,
    plus: IconTextPlus,
    pro: IconTextPro,
    like: IconHeartFilled,
    follow: IconProfileAddFilled,
    comment: IconCommentFilled,
    replay: IconReplay,
    newPost: IconImageFilled,
    save: IconBookmarkFilled,
    tag: IconTagFilled,
    mention: IconTagFilled,
    remix: IconEditFilled,
    sticker: IconStickerFilled,
    challenges: IconChallengesFilled,
    admin: IconAdminOutline,
    fileShare: IconShareFilled,
    fileJoined: IconPlus,
    plusCrown: IconCrownFilled,
    proCrown: IconCrownFilled,
    hot: IconFireFilled,
    gold: IconTextGold,
    plusReverse: IconTextPlusColored,
    proReverse: IconTextProColored,
    goldReverse: IconTextGoldColored,
    free: IconTextFree,
    aiAvatar: IconTextAIAvatar,
    proTrial: IconTextPro,
    plusTrial: IconTextPlus,
    crownTrial: IconCrownFilled,
    essentials: IconTextEssentials,
    performance: IconTextPerformance,
    lite: IconTextLite,
    max: IconTextMax,
    live: IconTextLive,
};

export { BadgeIcons, BadgeTypes };
